import React from 'react';
import { AppCasinoState } from 'src/domains/casino/state/AppCasino.state';
import { observer } from 'src/utils/mobx-react';
import { GridBody } from './grid-body/GridBody';
import { GridHeader } from './grid-header/GridHeader';
import { MobileWrapper, DesktopWrapper } from './MiniGamesGrid.style';
import { useCommon } from 'src/domains/common/Common';
import { BreakpointsState } from 'src/domains/layouts/state/breakpointsState/BreakpointsState';

interface PropsType {
    appCasinoState: AppCasinoState;
    isGameOpened: boolean;
}

export const MiniGamesGrid = observer('MiniGamesGrid', (props: PropsType) => {
    const { appCasinoState, isGameOpened } = props;

    const common = useCommon();
    const breakpointsState = BreakpointsState.get(common);
    const isDesktop = breakpointsState.desktop.isBiggerOrEq === true;

    if (isDesktop) {
        return (
            <DesktopWrapper>
                <GridHeader appCasinoState={appCasinoState} />
                <GridBody appCasinoState={appCasinoState} />
            </DesktopWrapper>
        );
    }

    const { isGamesListDisplayed, isTransitionFinished, isGamerGridDisplayed } = appCasinoState.miniGamesListState;

    return (
        <MobileWrapper
            isMobileGridOpen={isGamesListDisplayed && isGameOpened === false}
            onTransitionEnd={isTransitionFinished}
        >
            <GridHeader appCasinoState={appCasinoState} />
            {isGamerGridDisplayed ? <GridBody appCasinoState={appCasinoState} /> : null}
        </MobileWrapper>
    );
});
